export default "__VITE_ASSET__BwkD6ZBN__"